// Terminal command sequences for the landing page animation
// Inspired by real user interactions and suggestions

export const commandSequences = [
  {
    command: "find all pe files in /data/samples having .init section",
    responses: [
      { text: "Scanning 1000 files...", delay: 800 },
      { text: "Found 42 PE files with .init section", delay: 1500 },
      { text: "Analysis complete. View detailed report?", delay: 1200 }
    ]
  },
  {
    command: "is dolphine.exe a malicious file?",
    responses: [
      { text: "Analyzing dolphine.exe...", delay: 900 },
      { text: "PE Header: Valid PE32 executable", delay: 1000 },
      { text: "Checking signatures against threat database...", delay: 1200 },
      { text: "⚠️  Malicious file detected!", delay: 1000 },
      { text: "Threat: Trojan.Generic.Dolphine", delay: 800 }
    ]
  },
  {
    command: "scan this file hash on VirusTotal: 44d88612fea8a8f36de82e1278abb02f",
    responses: [
      { text: "Querying VirusTotal API...", delay: 1000 },
      { text: "Hash found in database.", delay: 800 },
      { text: "Detection Ratio: 58/72", delay: 800 },
      { text: "Verdict: Malicious (Ransomware.LockBit)", delay: 800 },
      { text: "View full analysis report?", delay: 1000 }
    ]
  },
  {
    command: "show me running processes consuming most memory",
    responses: [
      { text: "Collecting process information...", delay: 700 },
      { text: "PID: 1234  chrome.exe         2.4 GB", delay: 600 },
      { text: "PID: 5678  explorer.exe       1.8 GB", delay: 600 },
      { text: "PID: 9012  docker.exe         1.2 GB", delay: 600 },
      { text: "Total: 8 processes analyzed", delay: 800 }
    ]
  },
  {
    command: "list all network interfaces and their IP/MAC addresses",
    responses: [
      { text: "Enumerating network interfaces...", delay: 800 },
      { text: "eth0: 192.168.1.100 (00:1A:2B:3C:4D:5E)", delay: 700 },
      { text: "wlan0: 10.0.0.45 (AA:BB:CC:DD:EE:FF)", delay: 700 },
      { text: "lo: 127.0.0.1 (00:00:00:00:00:00)", delay: 700 },
      { text: "Total: 3 interfaces found", delay: 800 }
    ]
  },
  {
    command: "Can you extract the TTPs of this file C:\\Users\\cooluser\\Downloads\\dolphine.exe",
    responses: [
      { text: "Analyzing binary for TTPs...", delay: 1200 },
      { text: "Identifying MITRE ATT&CK techniques...", delay: 1000 },
      { text: "Found: T1055 (Process Injection)", delay: 600 },
      { text: "Found: T1082 (System Information Discovery)", delay: 600 },
      { text: "Found: T1012 (Query Registry)", delay: 600 },
      { text: "Analysis finished. 3 techniques identified.", delay: 800 }
    ]
  },
  {
    command: "print me the pe header of dolphine.exe",
    responses: [
      { text: "Reading PE structure...", delay: 900 },
      { text: "IMAGE_DOS_HEADER:", delay: 600 },
      { text: "  e_magic: 0x5A4D (MZ)", delay: 600 },
      { text: "  e_lfanew: 0x000000F0", delay: 600 },
      { text: "IMAGE_NT_HEADERS:", delay: 600 },
      { text: "  Machine: 0x014C (x86)", delay: 600 },
      { text: "  TimeDateStamp: 2024-01-15", delay: 700 }
    ]
  },
  {
    command: "lookup IOC 1.2.3.4 in ThreatFox",
    responses: [
      { text: "Querying ThreatFox database...", delay: 800 },
      { text: "IOC found: 1.2.3.4", delay: 600 },
      { text: "Threat Type: Botnet traffic", delay: 600 },
      { text: "Malware Family: Mirai", delay: 600 },
      { text: "Confidence: High (90%)", delay: 800 }
    ]
  },
  {
    command: "display all open/listening TCP and UDP ports",
    responses: [
      { text: "Scanning network connections...", delay: 800 },
      { text: "TCP  0.0.0.0:80       LISTENING", delay: 600 },
      { text: "TCP  0.0.0.0:443      LISTENING", delay: 600 },
      { text: "TCP  127.0.0.1:5432   LISTENING", delay: 600 },
      { text: "UDP  0.0.0.0:53       LISTENING", delay: 600 },
      { text: "Total: 12 ports open", delay: 800 }
    ]
  },
  {
    command: "can you tell me what disk partitions are there in this machine",
    responses: [
      { text: "Querying disk information...", delay: 800 },
      { text: "Disk Partitions Overview", delay: 600 },
      { text: "Internal physical disk: disk0", delay: 500 },
      { text: "• GUID_partition_scheme — 1.0 TB • disk0", delay: 400 },
      { text: "• Apple_APFS Container — 994.7 GB • disk0s2", delay: 400 },
      { text: "Synthesized disk: disk3", delay: 500 },
      { text: "• APFS Volume Macintosh HD — 11.3 GB • disk3s1", delay: 400 },
      { text: "• APFS Volume Data — 442.9 GB • disk3s5", delay: 400 }
    ]
  }
];

export default commandSequences;

